export default __webpack_public_path__ + "static/media/accident-icon.6865dc20.svg";